var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0BA7D"
    },
    d: "M228.546,238.629l-6.957,34.955l-23.307,8.016l13.793,217.594l88.682-0.503l4.142-221.201 l-14.885-4.683l-7.586-35.659L228.546,238.629L228.546,238.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M192.992,342.31c38.801,18.812,78.715,22.761,120.732,1.065l-1.432,162.402 C294.176,509.84,275.341,512,256,512c-22.256,0-43.846-2.844-64.432-8.182L192.992,342.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M297.499,275.471l67.592,18.434c17.527,5.411,33.188,15.775,33.689,34.4l3.707,137.649 c-15.404,10.768-32.048,19.876-49.674,27.085l-4.314-76.125l-11.837,82.104C311.304,507.439,284.186,512,256.001,512 c-0.736,0-1.466-0.022-2.201-0.028l-0.028-69.787L297.499,275.471z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M296.855,274.993l8.907,3.593l30.383,45.612l-35.613-0.573l22.074,11.812l-68.833,106.749 L296.855,274.993L296.855,274.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M218.424,274.774l-67.907,17.239c-17.622,5.103-33.46,15.188-34.291,33.801l-6.262,140.453 c15.269,10.625,31.75,19.624,49.193,26.762l5.78-77.732l10.575,83.779c24.647,8.163,50.956,12.666,78.287,12.897l-0.028-69.787 L218.424,274.774L218.424,274.774z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF3F7"
    },
    d: "M219.076,274.306l-10.62,4.068l-29.53,44.437l35.619,0.057l-22.28,11.42l61.508,107.897 L219.076,274.306L219.076,274.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M182.578,154.801c-1.135,11.456,1.159,36.892,15.056,35.924c0,0,20.002,58.295,58.511,64.896 c33.246-6.075,53.47-58.873,55.005-63.896c4.579,1.564,17.396-19.756,7.571-37.198c-2.818-5.002-10.795-0.952-10.795-0.952 l-0.614-14.565c-52.536,5.102-85.296-45.711-85.296-45.711c-20.027,21.785-24.845,34.219-26.987,61.314c0,0-3.761-2.335-7.936-2.424 C185.835,152.161,184.221,153.257,182.578,154.801L182.578,154.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M221.588,273.584l6.805-34.175c-19.713-19.409-29.992-48.684-29.992-48.684 c-13.432,1.498-18.826-35.521-9.789-36.814c4.133-0.592,6.9,0.703,6.9,0.703c2.035-28.608,7.545-37.307,26.503-61.314 c0,0,33.118,55.72,85.613,50.617l0.751,12.014c2.482-2.44,7.019-4.733,10.799,1.484c6.15,10.115-1.895,33.103-9.343,34.506 c-1.055,3.544-9.344,29.695-26.901,47.615l7.079,33.273c19.699,6.379,38.692,11.306,57.757,16.375 c-9.685-59.038-15.235-122.924-26.799-177.458c-11.098-52.331-71.765-66.967-106.652-43.726c0,0-30.082,12.121-35.574,52.32 c-5.49,40.197-3.389,44.071-3.389,44.071l-9.693,123.779C183.636,283.607,204.447,279.478,221.588,273.584L221.588,273.584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M348.527,418.914c-9.989-1.725-16.69-11.222-14.966-21.212c1.725-9.988,11.223-16.692,21.212-14.968 c9.991,1.725,16.691,11.225,14.967,21.216C368.015,413.939,358.517,420.639,348.527,418.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7986"
    },
    d: "M348.709,417.86c-9.408-1.625-15.719-10.566-14.094-19.975c1.625-9.409,10.568-15.721,19.978-14.096 c9.409,1.626,15.718,10.571,14.094,19.979C367.06,413.177,358.119,419.485,348.709,417.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBECEC"
    },
    d: "M350.022,410.253c-5.203-0.898-8.697-5.851-7.798-11.054c0.898-5.207,5.849-8.696,11.052-7.798 c5.207,0.899,8.698,5.846,7.799,11.053C360.178,407.658,355.229,411.151,350.022,410.253L350.022,410.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M351.147,392.425l4.204,0.725l2.26-13.09l-4.202-0.725L351.147,392.425L351.147,392.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M210.372,422.546l7.877-1.563c3.346-0.665,6.119-2.636,7.886-5.279 c1.765-2.643,2.532-5.957,1.866-9.304l-9.262-46.668c-3.496-17.61-17.273-26.591-33.016-28.581 c-6.033-0.764-12.357-0.486-18.483,0.729c-6.131,1.212-12.075,3.37-17.356,6.378c-13.754,7.833-23.024,21.378-19.522,39.017 l9.262,46.669c0.665,3.346,2.639,6.117,5.28,7.885l0.006-0.002c2.644,1.769,5.954,2.532,9.299,1.868l7.872-1.563l-0.644-3.245 l-7.874,1.563c-2.454,0.487-4.886-0.074-6.822-1.367l0.001-0.001c-1.938-1.299-3.386-3.331-3.874-5.781l-9.262-46.669 c-3.177-16.005,5.317-28.341,17.902-35.504c4.973-2.834,10.583-4.868,16.373-6.017c5.789-1.147,11.752-1.406,17.434-0.689 c14.408,1.821,27.009,9.982,30.178,25.956l9.265,46.669c0.486,2.452-0.078,4.881-1.372,6.822c-1.297,1.936-3.331,3.384-5.783,3.869 l-7.876,1.563L210.372,422.546L210.372,422.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M221.235,366.648l-1.415-7.129c-3.602-18.157-17.777-27.41-33.963-29.458 c-6.148-0.775-12.589-0.499-18.83,0.741c-6.243,1.236-12.3,3.436-17.682,6.498c-14.146,8.057-23.673,22.003-20.065,40.19 l1.417,7.129l5.405-1.075l-1.415-7.128c-3.067-15.458,5.168-27.392,17.362-34.337c4.874-2.774,10.369-4.766,16.047-5.892 c5.676-1.127,11.521-1.38,17.088-0.677c13.962,1.764,26.167,9.652,29.231,25.081l1.414,7.129L221.235,366.648L221.235,366.648z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#076673"
    },
    d: "M155.836,434.082l4.213-0.837c1.057,1.187,2.694,1.797,4.362,1.466 c2.507-0.497,4.136-2.932,3.638-5.441c-0.496-2.504-2.931-4.134-5.438-3.635c-1.671,0.331-2.95,1.522-3.472,3.021l-4.212,0.835 L155.836,434.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#076673"
    },
    d: "M213.72,422.593l-4.21,0.837c-0.523,1.498-1.802,2.689-3.471,3.02 c-2.506,0.496-4.94-1.132-5.438-3.64c-0.496-2.504,1.132-4.94,3.637-5.437c1.669-0.331,3.308,0.281,4.361,1.466l4.212-0.837 L213.72,422.593L213.72,422.593z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M169.59,330.379l-1.607-8.097l-3.195,0.636l-3.19,0.632l1.625,8.176 c1.217-0.356,2.449-0.657,3.693-0.903C167.802,330.646,168.694,330.499,169.59,330.379z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7986"
    },
    d: "M162.697,429.577c0.76-0.151,1.251-0.89,1.1-1.645c-0.15-0.759-0.885-1.253-1.645-1.102 c-0.76,0.151-1.251,0.887-1.101,1.646C161.202,429.233,161.938,429.728,162.697,429.577L162.697,429.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7986"
    },
    d: "M204.351,421.295c0.757-0.15,1.249-0.887,1.098-1.643c-0.151-0.76-0.885-1.253-1.645-1.103 c-0.76,0.151-1.251,0.887-1.1,1.648C202.853,420.952,203.59,421.445,204.351,421.295z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M349.511,410.164c-4.923-0.85-8.224-5.531-7.375-10.455c0.85-4.921,5.528-8.223,10.452-7.374 c4.922,0.85,8.225,5.529,7.376,10.451C359.114,407.711,354.433,411.014,349.511,410.164z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M208.563,278.563c-0.142,0.001-49.862,0.414-41.463,43.912l-4.623,0.884 c-9.468-49.038,45.874-49.49,46.032-49.492L208.563,278.563L208.563,278.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M307.775,274.091c8.111,0.218,23.794,2.429,35.861,17.111 c11.811,14.367,20.091,40.752,13.899,89.128l-4.661-0.59c5.993-46.823-1.751-72.031-12.866-85.554 c-10.86-13.211-25.019-15.202-32.344-15.399L307.775,274.091L307.775,274.091z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.c8f1bbe9dd49ff7d47fdbccd19db52d6.svg";
export { ForwardRef as ReactComponent };